export class StaticVariable {



  //  static porturl = 'http://localhost:8080/TicketBookingApi/';
  //  static printporturl = 'http://localhost:8080/TicketBookingApi/';

  static porturl = 'https://war.thirucadaiyurtemple.org/TicketBookingApi/';
  static printporturl = 'https://war.thirucadaiyurtemple.org/TicketBookingApi/';  

  // static porturl = 'http://eticket.devanathaswamytemple.org:8080/ThiruvanthipuramTicketBookingApi/';
  // static printporturl = 'http://eticket.devanathaswamytemple.org:8080/ThiruvanthipuramTicketBookingApi/';

  // static porturl = 'http://ticket.devanathaswamytemple.org:8080/ThiruvanthipuramMarriageBookingApi/';
  // static printporturl = 'http://ticket.devanathaswamytemple.org:8080/ThiruvanthipuramMarriageBookingApi/';

  // static porturl = 'http://emanagement.thirukkadaiyurabiramitemple.org:8080/TirukkadaiyurAbiramiTicketBookingApi/';
  // static printporturl = 'http://emanagement.thirukkadaiyurabiramitemple.org:8080/TirukkadaiyurAbiramiTicketBookingApi/';



  static loginTitle = 'TICKET BOOKING SOFTWARE';
  static loginPlace = 'Thirukkadavur - 6609 311';

  static templeNameEnglish = 'Arulmigu Amirtha Kadeswarar Temple';
  static placeNameEnglish = 'Thirukkadavur - 609 311';

  static templeNameTamil = 'அருள்மிகு அமிர்த கடேஸ்வரர் கோவில்';
  static placeNameTamil = ' திருக்கடையூர்- 609 311';

  static pageWidth = 230; // 297
  static pageHeight = 'auto'; //280
  static marginLeft = 10; //5
  static marginRight = 10; //5
  static marginTop = 10;
  static marginBottom = 10;
  static recColWidth1 = 34; //%
  static recColWidth2 = 10; //%
  static recColWidth3 = 56; //%
  static receiptHeader = true;
  static prebookingDuration = 2;
  static preBookingTime = '05:00';

  static printerName = 'EPSON TM-T82 Receipt';
  static printPreview = false;

  static status_1 = 'INITIAL';
  static status_2 = 'SUCCESS';

  static mail = '';
  static landLine = '04364 - 287429';
  static tollFree = '';

}


